module.exports = __webpack_public_path__ + "static/media/header.a2cf9f7d.mp4";